/* Pagina de produto da Arcan, feita pela The New Ads.
   Comportamentos: inclinacao da foto, zoom, quantidade, barra fixa de compra
   e o formulario que antecede o WhatsApp. */
(function () {
  'use strict';

  var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.dataLayer = window.dataLayer || [];

  /* ---- foto acompanha o ponteiro, mesmo gesto das cartas da home ---- */
  var palco = document.getElementById('arcan-stage');
  var foto = document.getElementById('arcan-stage-img');
  if (palco && foto && !reduz && window.matchMedia('(hover: hover)').matches) {
    palco.addEventListener('pointermove', function (e) {
      var r = palco.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      palco.classList.add('live');
      foto.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg');
      foto.style.setProperty('--rx', (-y * 10).toFixed(2) + 'deg');
    });
    palco.addEventListener('pointerleave', function () {
      palco.classList.remove('live');
      foto.style.setProperty('--ry', '0deg');
      foto.style.setProperty('--rx', '0deg');
    });
  }

  /* ---- zoom ---- */
  var dz = document.getElementById('arcan-zoom');
  var za = document.getElementById('arcan-zoom-open');
  var zf = document.getElementById('arcan-zoom-close');
  if (dz && za && typeof dz.showModal === 'function') {
    za.addEventListener('click', function () { dz.showModal(); });
    if (zf) zf.addEventListener('click', function () { dz.close(); });
    dz.addEventListener('click', function (e) { if (e.target === dz) dz.close(); });
  }

  /* ---- quantidade ---- */
  var campo = document.getElementById('arcan-qty');
  var menos = document.getElementById('arcan-qty-minus');
  var mais = document.getElementById('arcan-qty-plus');
  function sincroniza() {
    var v = parseInt(campo.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (v > 10) v = 10;
    campo.value = v;
    menos.disabled = v <= 1;
    mais.disabled = v >= 10;
  }
  if (campo && menos && mais) {
    menos.addEventListener('click', function () { campo.value = parseInt(campo.value, 10) - 1; sincroniza(); });
    mais.addEventListener('click', function () { campo.value = parseInt(campo.value, 10) + 1; sincroniza(); });
    campo.addEventListener('change', sincroniza);
    sincroniza();
  }

  /* ---- comprar agora vai pro checkout, adicionar a sacola fica no carrinho ---- */
  var retorno = document.getElementById('arcan-return');
  var comprar = document.getElementById('arcan-comprar');
  var sacola = document.getElementById('arcan-sacola');
  /* /cart, nao /checkout: a Yampi so intercepta quem passa pelo carrinho.
     Com skip_cart ligado la, o cliente segue indo direto para o pagamento. */
  if (retorno && comprar) comprar.addEventListener('click', function () { retorno.value = '/cart'; });
  if (retorno && sacola) sacola.addEventListener('click', function () { retorno.value = '/cart'; });

  /* ---- barra fixa: aparece quando o CTA do bloco do produto sai da tela ---- */
  var barra = document.getElementById('arcan-sticky');
  var cta = document.getElementById('arcan-comprar');
  if (barra && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      barra.classList.toggle('up', !e[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(cta);
  }
  var stickyCta = document.getElementById('arcan-sticky-cta');
  if (stickyCta && comprar) {
    stickyCta.addEventListener('click', function () {
      if (retorno) retorno.value = '/cart';
      comprar.click();
    });
  }

  /* O formulario que antecede o WhatsApp saiu daqui em 06/10/2026.
     Agora e global, em assets/arcan-whatsapp.js, e vale em toda pagina.
     Os botoes com data-arcan-lead continuam funcionando igual. */
})();
